import { Component, Input, OnInit } from '@angular/core';
import { AssetEvent } from '../../../core/store/models';

@Component({
    selector: 'ah-asset-event',
    templateUrl: './asset-event.component.html',
    styleUrls: ['./asset-event.component.scss'],
    standalone: false
})
export class AssetEventComponent implements OnInit {

    @Input() assetEvents: AssetEvent[]
    constructor() { }

    ngOnInit(): void {
    }

}
